import React, { FC } from 'react';
import '../style/chart_container.scss';
import { Ville } from '../../entity.types';

type Props = {
  villes: Array<Ville>;
  children: (data: { sortedVilles: Array<Ville> }) => React.ReactNode;
};

export const VillesChartContainer: FC<Props> = ({ children, villes }) => {
  const sortedVilles = villes.sort((v1, v2) => v2.count - v1.count);
  return (
    <div className="chart-container">
      {children({
        sortedVilles,
      })}
    </div>
  );
};
